export var PermissionCode;
(function (PermissionCode) {
    PermissionCode["CustomerRead"] = "customer.read";
    PermissionCode["CustomerWrite"] = "customer.write";
    PermissionCode["VehicleRead"] = "vehicle.read";
    PermissionCode["VehicleWrite"] = "vehicle.write";
    PermissionCode["RepairOrderRead"] = "repair_order.read";
    PermissionCode["RepairOrderWrite"] = "repair_order.write";
    PermissionCode["EstimateRead"] = "estimate.read";
    PermissionCode["EstimateWrite"] = "estimate.write";
    PermissionCode["LaborRead"] = "labor.read";
    PermissionCode["LaborWrite"] = "labor.write";
    PermissionCode["PartsRead"] = "parts.read";
    PermissionCode["PartsWrite"] = "parts.write";
    PermissionCode["InventoryRead"] = "inventory.read";
    PermissionCode["InventoryReceive"] = "inventory.receive";
    PermissionCode["InventoryIssue"] = "inventory.issue";
    PermissionCode["InventoryReturn"] = "inventory.return";
    PermissionCode["SupplierRead"] = "supplier.read";
    PermissionCode["SupplierWrite"] = "supplier.write";
    PermissionCode["PaymentRead"] = "payment.read";
    PermissionCode["PaymentCapture"] = "payment.capture";
    PermissionCode["PaymentRefund"] = "payment.refund";
    PermissionCode["InvoiceRead"] = "invoice.read";
    PermissionCode["InvoiceWrite"] = "invoice.write";
    PermissionCode["UserManage"] = "user.manage";
    PermissionCode["RoleManage"] = "role.manage";
    PermissionCode["ActivityLogRead"] = "activity_log.read";
})(PermissionCode || (PermissionCode = {}));
export var SystemRole;
(function (SystemRole) {
    SystemRole["Admin"] = "Admin";
    SystemRole["Advisor"] = "Advisor";
    SystemRole["Technician"] = "Technician";
    SystemRole["Warehouse"] = "Warehouse";
    SystemRole["Finance"] = "Finance";
    SystemRole["Manager"] = "Manager";
})(SystemRole || (SystemRole = {}));
